import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfService } from '../../config/conf.service';
import { ConnectWhatsAppAccount } from './meta-embedded-signup';

export interface WhatsAppConnectionStatus {
  isConnected: boolean;
  whatsAppBusinessAccountId?: string | null;
  phoneNumberId?: string | null;
  displayPhoneNumber?: string | null;
  businessName?: string | null;
  isSendingEnabled: boolean;
  connectedDate?: string | null;
  customerConsentConfirmedDate?: string | null;
}

export interface WhatsAppTemplateSummary {
  templateName: string;
  headerText: string;
  previewText: string;
  status?: string | null;
}

export interface WhatsAppTestMessageRequest {
  toNumber: string;
  text?: string;
  templateName?: string;
}

@Injectable({ providedIn: 'root' })
export class WhatsAppConnectionService {

  constructor(private http: HttpClient) { }

  getConnection(contextId: string, contextIdType: string): Observable<WhatsAppConnectionStatus> {
    return this.http.get<WhatsAppConnectionStatus>(this.url(contextId, contextIdType));
  }

  connect(contextId: string, contextIdType: string, signup: ConnectWhatsAppAccount): Observable<WhatsAppConnectionStatus> {
    return this.http.post<WhatsAppConnectionStatus>(this.url(contextId, contextIdType), signup);
  }

  setSending(contextId: string, contextIdType: string, isSendingEnabled: boolean,
    isCustomerConsentConfirmed = false): Observable<WhatsAppConnectionStatus> {
    return this.http.put<WhatsAppConnectionStatus>(`${this.url(contextId, contextIdType)}/sending`,
      { isSendingEnabled, isCustomerConsentConfirmed });
  }

  disconnect(contextId: string, contextIdType: string): Observable<WhatsAppConnectionStatus> {
    return this.http.delete<WhatsAppConnectionStatus>(this.url(contextId, contextIdType));
  }

  getTemplates(contextId: string, contextIdType: string): Observable<WhatsAppTemplateSummary[]> {
    return this.http.get<WhatsAppTemplateSummary[]>(`${this.url(contextId, contextIdType)}/templates`);
  }

  sendTestMessage(contextId: string, contextIdType: string, request: WhatsAppTestMessageRequest): Observable<void> {
    return this.http.post<void>(`${this.url(contextId, contextIdType)}/testMessage`, request);
  }

  private url(contextId: string, contextIdType: string): string {
    return `${ConfService.apiUrl()}/rest/whatsAppConnection/${encodeURIComponent(contextId)}/${encodeURIComponent(contextIdType)}`;
  }
}
